import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres62e/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres62e/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_dtereq_st: (typeof searchParams.dtereqst !== 'undefined' ? searchParams.dtereqst : ''),
        p_dtereq_en: (typeof searchParams.dtereqen !== 'undefined' ? searchParams.dtereqen : ''),
        p_codempid: (typeof searchParams.codempid !== 'undefined' ? searchParams.codempid : '')
      }
    }
    return instance().get(endpoint + '/hres62e/index', { params: sendParams })
  },
  getDetail (searchParams) {
    if (isMock) return generator(mocker.detail())
    const params = searchParams.p_dtereq.replace(/\//g, '') + '/' + searchParams.p_numseq
    return instance().get(endpoint + '/hres62e/update/' + params)
  },
  getCreate (searchParams) {
    if (isMock) return generator(mocker.create())
    return instance().get(endpoint + '/hres62e/create', { params: searchParams })
  },
  getDropdowns () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hres62e/dropdowns')
  },
  getPopup (popupParams) {
    let searchParams = {
      p_codleave: popupParams.codleave
    }
    const params = searchParams.p_codleave
    if (isMock) return generator(mocker.popup())
    return instance().get(endpoint + '/hres62e/getPopup/' + params)
  },
  getCodleave (searchParams) {
    if (isMock) return generator(mocker.getCodleave())
    const params = searchParams.p_dtework.replace(/\//g, '') + '/' + searchParams.p_codempid_query
    return instance().get(endpoint + '/hres62e/getCodleave/' + params)
  },
  postSave ({ saveParams, searchIndex }) {
    if (isMock) return generator(mocker.save())
    return instance().post(endpoint + '/hres62e/update', saveParams)
  },
  postCancel ({ sendParams, searchIndex }) {
    if (isMock) return generator(mocker.cancel())
    return instance().post(endpoint + '/hres62e/cancel', sendParams)
  },
  getEntitleFlagLeave (searchParams) {
    if (isMock) return generator(mocker.entitleFlagLeave())
    return instance().post(endpoint + '/hres62e/entitleFlagLeave', searchParams)
  },
  getWorktime (searchParams) {
    if (isMock) return generator(mocker.worktime())
    return instance().get(endpoint + '/hres62e/workTime', { params: searchParams })
  }
}



// WEBPACK FOOTER //
// ./src/api/hres62e/index.js